#@import Booking.Presenters.Booker
#@import Booking.Views.Base
#@import Booking.Views.Info
#@import Booking.Views.Pickers
#@import Booking.Views.OptionPicker
#@import Booking.Views.DateTimePicker
#@import Booking.Views.PartySizePicker
#@import Booking.Views.Question
#@import Booking.Views.Phone
#@import Booking.Views.TextNotifications
#@import Booking.Views.Book
#@import Booking.Views.Tooltip
#@export Booking.Views.Booker

class Booking.Views.Booker extends Booking.Views.Base

  presenter: Booking.Presenters.Booker

  className: 'booking-component'

  events:
    'submit form': 'book'

  viewClasses: {
    question: Booking.Views.Question
    phone: Booking.Views.Phone
    textNotifications: Booking.Views.TextNotifications
    pickers: Booking.Views.Pickers
    info: Booking.Views.Info
    book: Booking.Views.Book
    partysizepicker: Booking.Views.PartySizePicker
    datetimepicker: Booking.Views.DateTimePicker
    optionpicker: Booking.Views.OptionPicker
  }

  constructor: ->
    Booking.Views.Base.apply this, arguments

    @views = {}

    # Should show errors when getting reservations or availability
    @listenTo @model.getAvailability(), 'error', @errorLoading
    @listenTo @model.getReservations(), 'error', @errorBooking

    # Should properly set bhw tags
    @bhw "#{Booking.bhw}Widget"

    # Should take care of re-rendering sections when the associated values change
    @listenTo @model, 'change:selectedOption', @renderInfo
    @listenTo @model, 'change:selectedOption', @renderPickers
    @listenTo @model, 'change:selectedOption', @renderQuestion
    @listenTo @model, 'change:selectedOption', @renderPhone
    @listenTo @model, 'change:selectedOption', @renderBookButton
    @listenTo @model, 'change:selectedOption', @renderTextNotifications
    @listenTo @model, 'change:selectedTimes', @renderBookButton
    @listenTo @model, 'change:selectedPartySize', @renderBookButton
    @listenTo @model, 'change:phoneNumber', @renderBookButton
    @listenTo @model, 'change:questionsAnswer', @renderBookButton
    @listenTo @model, 'change:isBooking', @renderBookButton

    Booking.Views.Base::render.apply this, arguments

    # We want to create views when the model is instantiated
    @createView(name: 'info')
    @createPickers()
    @createDrawers()
    @createView(name: 'book')

  createDrawers: ->

    @createView
      name: 'phone'
      options:
        customerPhoneMaxLength: @options.metasSettings.customerPhoneMaxLength
      events:
        complete: @phoneInputComplete

    @createView
      name: 'question'
      options:
        maxLength: @options.metasSettings.answerMaxLength

    @createView
      name: 'textNotifications'
      events:
        toggle: @toggleTextNotifications

  createPickers: ->
    pickersView = @createView(name: 'pickers')

    if @canRenderOptions()
      pickersView.add
        view: @viewClasses['optionpicker']
        model: @model
        collection: 'options'
        pickerAttributes: ['selectedOption']

    pickersView.add
      view: @viewClasses['partysizepicker']
      model: @model
      collection: 'partySizes'
      pickerAttributes: ['selectedPartySize']

    pickersView.add
      view: @viewClasses['datetimepicker']
      model: @model
      collection: 'availability'
      pickerAttributes: ['selectedDate', 'selectedTimes']

    # Review these two events
    pickersView.on 'pickers:collapse', => @pickersCollapsed()
    pickersView.once 'pickers:expanded', => @trigger 'ready'

  pickersCollapsed: ->
    if @model.requirePhone() and not @model.getPhoneNumber()
      @views['phone'].focus()
    else if @model.requireQuestion() and not @model.getQuestionsAnswer()
      @views['question'].focus()

  renderInfo: ->
    @renderView('info', @options.showInfo is true)

  renderPickers: ->
    @renderView('pickers')

  renderQuestion: ->
    @renderView('question')

  renderPhone: ->
    @renderView('phone')

  renderTextNotifications: ->
    @renderView('textNotifications')

  renderBookButton: ->
    @renderView('book', true)

  setOpen: ->
    $(@options.overlapWith).hide() if @options.overlapWith
    @options.isOpen = true

  setOpenAndLocked: ->
    @setOpen()
    @options.isLocked = true

  setClosed: ->
    @options.isOpen = false

  open: ->
    OptimizeSuite.TrackingHub.add("booking-widget-opened", null)
    @setOpen()
    @model.reset()
    @render(fadeIn: true)

  close: ->
    OptimizeSuite.TrackingHub.add("booking-widget-closed", null)
    @setClosed()
    @$el.fadeOut =>
      @render(show: true)
      $(@options.overlapWith).fadeIn() if @options.overlapWith
      @model.resetOption()

  canBeClosed: ->
    @options.isOpen and not @options.keepOpen

  render: ->
    Booking.Views.Base::render.apply this, arguments

    unless @model.getError()
      @renderInfo()
      @renderPickers()
      @renderQuestion()
      @renderPhone()
      @renderTextNotifications()
      @renderBookButton()

    @$el.fadeIn() if arguments[0]?.fadeIn is true
    @$el.show() if arguments[0]?.show is true

    @setOpen()
    return this

  canRenderOptions: ->
    @options.optionSelectable and @model.hasMultipleOptions()

  phoneInputComplete: ->
    @views['question']?.focus() if @model.requireQuestion()

  book: (event) ->
    event.stopPropagation()
    @showInvalidIfNeeded()
    @model.book()
    false

  showInvalidIfNeeded: ->
    for viewName, view of @views
      if viewName is 'pickers'
        for picker in view.pickers
          picker.showInvalid() if picker.shouldShowInvalid()
      else
        if typeof view.showInvalid is 'function'
          view.showInvalid() if view.shouldShowInvalid()

  errorLoading: (type) ->
    @error('loading') unless type?

  errorBooking: (reservation) ->
    @error(reservation.getError())

  error: (error) ->
    @model.setError(error)
    if @canBeClosed() then @close() else @render()

# Subview helpers
  renderView: (name, force = false) ->
    view = @views[name]
    viewEl = @viewEl(name)

    if force or view.canRender()
      view.setElement(viewEl)
      view.render()
    else
      viewEl.html('')

  viewEl: (name) ->
    @$el.find("[data-#{name.toLowerCase()}-content]")

  createView: ({name, options, events}) ->
    @views[name] = new @viewClasses[name] _.extend({el: @viewEl(name), model: @model}, options)
    @listenTo(@views[name], eventName, eventCb) for eventName, eventCb of events
    return @views[name]

